import React, { forwardRef } from "react";

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    value?: string; // The value of the input
    onClick?: React.MouseEventHandler<HTMLDivElement>; // The onClick handler
    onBlur?: React.FocusEventHandler<HTMLInputElement>; // The onBlur handler
  }

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
    ({ value, onClick, onBlur, ...props }, ref) => (
    <div className="custom-date-picker-input">
      <input
        type="text"
        className={`form-control ${props.className}`}
        value={value}
        onClick={onClick}
        ref={ref}
        placeholder="Select a date"
        readOnly
        onBlur={onBlur}
      />
      <i
        className="sprites sprite-calendar-gray date-picker-icon"
        onClick={onClick}
        aria-label="Open calendar"
      ></i>
    </div>
  ));

export default CustomInput;